import { ChevronRight } from "lucide-react";
import { QuickFilters, ShareNetworkButton, TrustStrip, HubTicker } from "@/components/fleet/HeroExtras";
import { HeroSearch, HeroQuickChips } from "@/components/fleet/HeroSearch";
import { formatEuro } from "@/lib/api";
import { t } from "@/lib/i18n";

const Stat = ({ label, value, testid, accent }) => (
  <div className="ff-card px-4 py-3 flex flex-col gap-1 min-w-0">
    <span className="text-[11px] font-bold uppercase tracking-[0.08em] text-[#94A3B8]">{label}</span>
    <span data-testid={testid} className={`ff-display text-xl sm:text-2xl font-extrabold truncate ${accent || "text-white"}`}>{value}</span>
  </div>
);

const LicenseBanner = ({ onProfile }) => (
  <button type="button" data-testid="hero-complete-profile-button" onClick={onProfile} className="w-full mb-6 px-4 py-3 rounded-2xl flex items-center gap-3 text-left bg-white/[0.04] backdrop-blur-xl border border-[#10B981]/50 hover:border-[#10B981] transition-colors shadow-[0_0_24px_rgba(16,185,129,0.12)]">
    <span data-testid="license-banner-text" className="flex-1 text-sm sm:text-base font-semibold text-white leading-snug">
      {t("🛡️ Ottieni il badge NCC Verificato • Carica la licenza nel Profilo (facoltativo)")}
    </span>
    <ChevronRight size={22} className="text-[#94A3B8] shrink-0" />
  </button>
);

export const Hero = ({ stats, online, verified, onCreate, onSearch, onProfile, vehicle, onVehicle, q, onQuery, hub, onHub, service, onService }) => (
  <section className="pt-6 sm:pt-10 pb-10" data-testid="hero-section">
    <HubTicker hubs={stats?.hubs} online={online} />
    {!verified && <LicenseBanner onProfile={onProfile} />}
    <h1 className="ff-rise ff-display font-extrabold leading-[1.02] text-4xl sm:text-5xl lg:text-6xl max-w-3xl">
      {t("Cedi o prendi una corsa.")} <span className="text-[#10B981]">{t("In due tap.")}</span>
    </h1>
    <p data-testid="hero-subtitle" className="mt-4 max-w-xl text-base sm:text-lg text-[#94A3B8] leading-relaxed">
      {t("Il network B2B intelligente che trasforma ogni tratta in un'opportunità di guadagno.")}
    </p>
    <div className="mt-7 grid grid-cols-1 sm:grid-cols-2 gap-3 max-w-2xl">
      <button type="button" data-testid="hero-create-ride-button" onClick={onCreate} className="ff-btn-primary h-16 px-6 text-base uppercase">
        {t("CEDI / CARICA CORSA")}
      </button>
      <HeroSearch q={q} onQuery={onQuery} onSearch={onSearch} />
    </div>
    <HeroQuickChips hub={hub} onHub={onHub} service={service} onService={onService} />
    <QuickFilters vehicle={vehicle} onVehicle={onVehicle} />
    <ShareNetworkButton />
    <div className="mt-6 grid grid-cols-3 gap-2 sm:gap-3 max-w-2xl">
      <Stat label={t("Corse live")} value={stats ? stats.available : "—"} testid="stat-available-rides" accent="text-[#10B981]" />
      <Stat label={t("In bacheca")} value={stats ? formatEuro(stats.board_value) : "—"} testid="stat-board-value" />
      <Stat label={t("Bloccate")} value={stats ? stats.booked : "—"} testid="stat-booked-rides" />
    </div>
    <TrustStrip />
  </section>
);
